/**
 * Evaluates field visibility/state conditions against current form values.
 * Returns an object { visible, disabled, required } for the field.
 */
export function evaluateConditions(fieldDef, formValues) {
    const result = { visible: true, disabled: false, required: false };

    if (!fieldDef.conditions || fieldDef.conditions.length === 0) {
        // Use the validation required as default
        if (fieldDef.validation && fieldDef.validation.required) {
            result.required = true;
        }
        return result;
    }

    // Set required from validation as baseline
    if (fieldDef.validation && fieldDef.validation.required) {
        result.required = true;
    }

    for (let i = 0; i < fieldDef.conditions.length; i++) {
        const condition = fieldDef.conditions[i];
        const dependsOnValue = formValues[condition.dependsOn];
        const conditionMet = evaluateSingleCondition(dependsOnValue, condition.operator, condition.value);

        switch (condition.action) {
            case 'show':
                if (!conditionMet) {
                    result.visible = false;
                }
                break;
            case 'hide':
                if (conditionMet) {
                    result.visible = false;
                }
                break;
            case 'disable':
                if (conditionMet) {
                    result.disabled = true;
                }
                break;
            case 'enable':
                if (!conditionMet) {
                    result.disabled = true;
                }
                break;
            case 'require':
                if (conditionMet) {
                    result.required = true;
                }
                break;
            default:
                break;
        }
    }

    return result;
}

function evaluateSingleCondition(actualValue, operator, expectedValue) {
    switch (operator) {
        case 'equals':
            return actualValue === expectedValue;
        case 'notEquals':
            return actualValue !== expectedValue;
        case 'contains':
            if (Array.isArray(actualValue)) {
                return actualValue.includes(expectedValue);
            }
            return String(actualValue || '').includes(String(expectedValue || ''));
        case 'notContains':
            if (Array.isArray(actualValue)) {
                return !actualValue.includes(expectedValue);
            }
            return !String(actualValue || '').includes(String(expectedValue || ''));
        case 'isEmpty':
            return !actualValue || (Array.isArray(actualValue) && actualValue.length === 0) || actualValue === '';
        case 'isNotEmpty':
            return actualValue && (!Array.isArray(actualValue) || actualValue.length > 0) && actualValue !== '';
        case 'in':
            if (Array.isArray(expectedValue)) {
                return expectedValue.includes(actualValue);
            }
            return false;
        case 'notIn':
            if (Array.isArray(expectedValue)) {
                return !expectedValue.includes(actualValue);
            }
            return true;
        default:
            return false;
    }
}
